/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { useState, useEffect } from 'react';
import { useIsMounted } from '../index';

export default (isLoading, minTime = 1000) => {
  const { ifIsMounted } = useIsMounted();

  const [shouldShowLoader, setShouldShowLoader] = useState(isLoading);

  const [lastUpdatedAt, setLastUpdatedAt] = useState(new Date());

  // watch isLoading for changes
  useEffect(() => {
    // if we're no longer loading
    if (!isLoading) {
      // see how much time has passed
      const timeElapsedInMs = new Date() - lastUpdatedAt;
      // calculate how much time is left until we reach minimum loading time
      const timeLeft = minTime - timeElapsedInMs;
      // if there is time left, use setTimeout to set state
      if (timeLeft > 0) {
        setTimeout(() => {
          ifIsMounted(() => setShouldShowLoader(false));
        }, timeLeft);
        return;
      }
      // else just hide loader immediately
      setShouldShowLoader(false);
      return;
    }

    setShouldShowLoader(true);
    setLastUpdatedAt(new Date());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  return {
    shouldShowLoader,
  };
};
